// @flow
import React, { type Node, useState } from 'react';
import styled, { type StyledComponent } from 'styled-components';
import isEmpty from 'lodash-es/isEmpty';

import type { Pet } from '@rover/react-lib/types';
import { SexInfoConstants } from '@rover/shared/js/constants/translation';

import PetSexInfo from './PetSexInfo';
import SectionTitle from '../common/SectionTitle';
import SectionSaveButton from '../common/SectionSaveButton';

type Props = {
  pets: Array<Pet>,
  handleSave: () => void,
  handleUpdate: (pet: Pet) => void,
  isSexComplete: (url: string, field: string) => boolean,
  showNames: boolean,
};

const SectionWrapper: StyledComponent<{}> = styled.div`
  margin-left: 45px;
  margin-right: 45px;
`;

const SexInfo = ({ pets, handleSave, handleUpdate, isSexComplete, showNames }: Props): Node => {
  const [currentlyEditing, setCurrentlyEditing] = useState({});

  const toggleEditing = pet =>
    setCurrentlyEditing({ ...currentlyEditing, [pet.url]: !currentlyEditing[pet.url] });

  const isFormComplete =
    isEmpty(currentlyEditing) && pets.every(pet => isSexComplete(pet.url, 'gender'));

  const save = () => {
    handleSave();
    setCurrentlyEditing({});
  };

  pets.forEach(pet => {
    if (!pet.gender && !currentlyEditing[pet.url]) {
      toggleEditing(pet);
    }
  });

  const isEditing = pet => currentlyEditing[pet.url] || !isSexComplete(pet.url, 'gender');

  return (
    <SectionWrapper>
      <SectionTitle
        isComplete={isFormComplete}
        titleText={SexInfoConstants.title}
        incompleteText={SexInfoConstants.required}
      />
      {pets.map(pet => (
        <PetSexInfo
          key={pet.url}
          pet={pet}
          showNames={showNames}
          handleSexInfoChange={(gender: string) => handleUpdate({ ...pet, gender })}
          value={pet.gender}
          isEditing={isEditing(pet)}
          toggleEditing={toggleEditing}
        />
      ))}
      <SectionSaveButton
        isComplete={isFormComplete}
        buttonText={SexInfoConstants.save}
        saveMethod={save}
        currentlyEditing={currentlyEditing}
      />
    </SectionWrapper>
  );
};

export default SexInfo;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/SexInfo/SexInfo.jsx